import { Flex, theme } from 'antd'
import { HelpCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { IconWithBackground } from 'src/components'

import { ChatMarkdown } from './ChatMarkdown'
import { useStyles } from './styles'
import type { QuestionResolution } from './types'

const HEADER_ICON_SIZE = 22

type Props = {
  question: string
  resolution: QuestionResolution
}

export const ResolvedQuestionCard = ({ question, resolution }: Props) => {
  const { styles } = useStyles()
  const { token } = theme.useToken()
  const { t } = useTranslation()
  const selected = [
    ...resolution.selected,
    ...(resolution.other ? [resolution.other] : [])
  ]

  return (
    <div className={styles.questionCard}>
      <Flex align="center" gap={8} className={styles.questionHeader}>
        <IconWithBackground
          size={HEADER_ICON_SIZE}
          shape="square"
          color={token.colorInfo}
        >
          <HelpCircle size={14} />
        </IconWithBackground>
        <div className={styles.questionSummaryLabel}>
          {t('workspaceHome.question.questionLabel')}
        </div>
      </Flex>

      <div className={styles.questionText}>
        <ChatMarkdown content={question} />
      </div>

      <div className={styles.questionSelection}>
        <span className={styles.questionSummaryLabel}>
          {t('workspaceHome.question.selected')}:
        </span>{' '}
        {selected.join(', ')}
      </div>
    </div>
  )
}
